"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const svg_1 = require("../../../svg");
const graphql_1 = require("../../../graphql");
const Routes_1 = require("./Routes");
const OsmosysResourcePage_1 = require("../../../comps/reusables/OsmosysResourcePage");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.WorkflowDetail = () => {
    const { match } = use_react_router_1.default();
    return (react_1.default.createElement(reusables_1.OsmosysResourcePage, { query: graphql_1.workflow, paths: {
            item: 'workflow',
        }, variables: { id: match.params.id }, 
        // headerColor="progress-bar-striped bg-warning"
        getSubTitle: data => {
            if (data.workflow.archived) {
                return 'Archived Workflow';
            }
            return 'Active Workflow';
        }, getTitle: data => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(svg_1.WorkflowsLogo, { width: "36", height: "36", className: "mr-2" }),
            data.workflow.name)) },
        react_1.default.createElement(OsmosysResourcePage_1.OsmosysResourcePageInner, null, data => react_1.default.createElement(Routes_1.Routes, { workflow: data.workflow }))));
};
exports.default = exports.WorkflowDetail;
//# sourceMappingURL=index.js.map